import { EventEmitter, Component, Injector, Input, Output, NgModule } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { DefaultPhoneTypes, MtPhoneControlModule } from '@mt-ng2/phone-control';
import { ClaimsService, ClaimValues } from '@mt-ng2/auth-module';
import { NotificationsService } from '@mt-ng2/notifications-module';
import { markAllFormFieldsAsTouched } from '@mt-ng2/common-functions';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DynamicFormModule } from '@mt-ng2/dynamic-form';
import { MtAlertsModule } from '@mt-ng2/alerts-module';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';
import * as ɵngcc3 from '@mt-ng2/phone-control';

function CommonPhoneComponent_div_1_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtext(1, "\n                    ");
    ɵngcc0.ɵɵelement(2, "i", 7);
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelementEnd();
} }
function CommonPhoneComponent_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3, "\n                    ");
    ɵngcc0.ɵɵelementStart(4, "b");
    ɵngcc0.ɵɵtext(5, "Primary Phone:");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "phone");
    ɵngcc0.ɵɵpipe(8, "primary");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(9, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate1("\n                    ", ɵngcc0.ɵɵpipeBind1(7, 1, ɵngcc0.ɵɵpipeBind1(8, 3, ctx_r3.phones)), "\n                ");
} }
function CommonPhoneComponent_div_1_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelementStart(2, "i");
    ɵngcc0.ɵɵtext(3, "No Phones");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} }
function CommonPhoneComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵlistener("click", function CommonPhoneComponent_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.selectPhone(); });
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "h4");
    ɵngcc0.ɵɵtext(3, "\n                Phone\n                ");
    ɵngcc0.ɵɵtemplate(4, CommonPhoneComponent_div_1_span_4_Template, 4, 0, "span", 3);
    ɵngcc0.ɵɵtext(5, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n            ");
    ɵngcc0.ɵɵtemplate(7, CommonPhoneComponent_div_1_div_7_Template, 10, 5, "div", 4);
    ɵngcc0.ɵɵpipe(8, "primary");
    ɵngcc0.ɵɵtext(9, "\n            ");
    ɵngcc0.ɵɵtemplate(10, CommonPhoneComponent_div_1_div_10_Template, 5, 0, "div", 5);
    ɵngcc0.ɵɵtext(11, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("cursor", ctx_r0.canEdit ? "pointer" : "default");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEdit);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(8, 5, ctx_r0.phones));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.phones || ctx_r0.phones.length === 0);
} }
function CommonPhoneComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "form", 10);
    ɵngcc0.ɵɵlistener("ngSubmit", function CommonPhoneComponent_div_3_Template_form_ngSubmit_2_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.savePhones(); });
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelementStart(4, "h4");
    ɵngcc0.ɵɵtext(5, "Phone");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n                ");
    ɵngcc0.ɵɵelementStart(7, "div");
    ɵngcc0.ɵɵtext(8, "\n                    ");
    ɵngcc0.ɵɵelementStart(9, "label", 11);
    ɵngcc0.ɵɵtext(10, "Phone Number(s)");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(11, "\n                    ");
    ɵngcc0.ɵɵelement(12, "app-mt-phone", 12);
    ɵngcc0.ɵɵtext(13, "\n                    ");
    ɵngcc0.ɵɵelement(14, "br");
    ɵngcc0.ɵɵtext(15, "\n                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(16, "\n                ");
    ɵngcc0.ɵɵelementStart(17, "button", 13);
    ɵngcc0.ɵɵtext(18, "Save");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(19, "\n                ");
    ɵngcc0.ɵɵelementStart(20, "button", 14);
    ɵngcc0.ɵɵlistener("click", function CommonPhoneComponent_div_3_Template_button_click_20_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.cancel(); });
    ɵngcc0.ɵɵtext(21, "Cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(22, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(23, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r1.phoneForm);
    ɵngcc0.ɵɵadvance(10);
    ɵngcc0.ɵɵproperty("PhoneArray", ctx_r1.PhoneArray)("PhoneTypes", ctx_r1.PhoneTypes)("parentForm", ctx_r1.phoneForm)("canAdd", ctx_r1.canAdd);
} }
class CommonPhoneComponent {
    constructor(injector) {
        this.onSave = new EventEmitter();
        this._isEditing = false;
        this.newPhone = {
            Extension: '',
            IsPrimary: true,
            Phone: '',
            PhoneTypeId: 2,
        };
        this.phones = [];
        this.subscriber = new Subscription();
        this.fb = injector.get(FormBuilder);
        this.route = injector.get(ActivatedRoute);
        this.claimsService = injector.get(ClaimsService);
        this.notificationsService = injector.get(NotificationsService);
    }
    get canEdit() {
        return this._canEdit;
    }
    set canEdit(value) {
        this._canEdit = value;
    }
    get canAdd() {
        return this._canAdd;
    }
    set canAdd(value) {
        this._canAdd = value;
    }
    set PhoneArray(value) {
        this._phones = value;
        this.phones = value;
        // this.selectedPhone = null;
    }
    get PhoneArray() {
        return this._phones;
    }
    get isEditing() {
        return this._isEditing && this._canEdit;
    }
    set isEditing(value) {
        this._isEditing = value;
    }
    ngOnInit() {
        this.phoneForm = new FormGroup({});
        this.setVariables();
    }
    ngOnDestroy() {
        this.subscriber.unsubscribe();
    }
    setVariables() {
        const config = this.route.parent.snapshot.data;
        if (this._canEdit === undefined) {
            this._canEdit = (config === null || config === void 0 ? void 0 : config.claimType) ? this.claimsService.hasClaim(config.claimType, [ClaimValues.FullAccess]) : false;
        }
        if (this._canAdd === undefined) {
            this._canAdd = this._canEdit;
        }
        if (!this.PhoneTypes) {
            this.PhoneTypes = DefaultPhoneTypes;
        }
    }
    savePhones() {
        // TODO: is this how we handle touched?
        if (this.phoneForm.valid) {
            const phoneCollection = {
                Phones: this.getPhonesFromForm(this.phoneForm),
            };
            this.onSave.emit(phoneCollection);
            const phoneGroups = phoneCollection.Phones.sort((a, b) => {
                return (b.IsPrimary ? 1 : 0) - (a.IsPrimary ? 1 : 0);
            }).map((phone) => this.fb.group(phone));
            const phones = this.fb.array(phoneGroups);
            this.phoneForm.setControl('phones', phones);
            this.isEditing = false;
        }
        else {
            this.notificationsService.error('Save Failed');
            markAllFormFieldsAsTouched(this.phoneForm);
        }
    }
    getPhonesFromForm(form) {
        const Phones = [];
        form.value.phones.forEach((phone) => {
            var _a;
            phone.Phone = phone.Phone.replace(/\D/g, '');
            if (((_a = phone.Phone) === null || _a === void 0 ? void 0 : _a.length) >= 10) {
                phone.Phone = phone.Phone.substring(0, 10);
                Phones.push(phone);
            }
        });
        return Phones;
    }
    selectPhone() {
        this.isEditing = true;
    }
    cancel() {
        this.isEditing = false;
    }
}
CommonPhoneComponent.ɵfac = function CommonPhoneComponent_Factory(t) { return new (t || CommonPhoneComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
CommonPhoneComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CommonPhoneComponent, selectors: [["app-common-phone"]], inputs: { canEdit: "canEdit", canAdd: "canAdd", PhoneArray: "PhoneArray", PhoneTypes: "PhoneTypes", editingComponent: "editingComponent" }, outputs: { onSave: "onSave" }, decls: 5, vars: 2, consts: [["class", "miles-editable miles-card padded", 3, "cursor", "click", 4, "ngIf"], ["class", "miles-form padded", 4, "ngIf"], [1, "miles-editable", "miles-card", "padded", 3, "click"], ["class", "pull-right show-on-hover", 4, "ngIf"], ["class", "display-padded", 4, "ngIf"], [4, "ngIf"], [1, "pull-right", "show-on-hover"], [1, "fa", "fa-lg", "fa-edit"], [1, "display-padded"], [1, "miles-form", "padded"], [3, "formGroup", "ngSubmit"], ["for", "phoneNumbers"], [3, "PhoneArray", "PhoneTypes", "parentForm", "canAdd"], ["type", "submit", 1, "btn", "btn-flat", "btn-success"], [1, "btn", "btn-default", "btn-flat", 3, "click"]], template: function CommonPhoneComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵtemplate(1, CommonPhoneComponent_div_1_Template, 12, 7, "div", 0);
        ɵngcc0.ɵɵtext(2, "\n        ");
        ɵngcc0.ɵɵtemplate(3, CommonPhoneComponent_div_3_Template, 24, 5, "div", 1);
        ɵngcc0.ɵɵtext(4, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isEditing);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isEditing);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.ɵangular_packages_forms_forms_y, ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc3.MtPhoneComponent], pipes: [ɵngcc3.IsPrimaryPipe, ɵngcc3.PhonePipe], encapsulation: 2 });
CommonPhoneComponent.ctorParameters = () => [
    { type: Injector }
];
CommonPhoneComponent.propDecorators = {
    editingComponent: [{ type: Input }],
    canEdit: [{ type: Input, args: ['canEdit',] }],
    canAdd: [{ type: Input, args: ['canAdd',] }],
    PhoneArray: [{ type: Input, args: ['PhoneArray',] }],
    PhoneTypes: [{ type: Input, args: ['PhoneTypes',] }],
    onSave: [{ type: Output, args: ['onSave',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CommonPhoneComponent, [{
        type: Component,
        args: [{
                selector: 'app-common-phone',
                template: `
        <div class="miles-editable miles-card padded" *ngIf="!isEditing" (click)="selectPhone()" [style.cursor]="canEdit ? 'pointer' : 'default'">
            <h4>
                Phone
                <span class="pull-right show-on-hover" *ngIf="canEdit">
                    <i class="fa fa-lg fa-edit"></i>
                </span>
            </h4>
            <div *ngIf="phones | primary" class="display-padded">
                <span>
                    <b>Primary Phone:</b>
                    {{ phones | primary | phone }}
                </span>
            </div>
            <div *ngIf="!phones || phones.length === 0">
                <i>No Phones</i>
            </div>
        </div>
        <div class="miles-form padded" *ngIf="isEditing">
            <form [formGroup]="phoneForm" (ngSubmit)="savePhones()">
                <h4>Phone</h4>
                <div>
                    <label for="phoneNumbers">Phone Number(s)</label>
                    <app-mt-phone [PhoneArray]="PhoneArray" [PhoneTypes]="PhoneTypes" [parentForm]="phoneForm" [canAdd]="canAdd"></app-mt-phone>
                    <br />
                </div>
                <button type="submit" class="btn btn-flat btn-success">Save</button>
                <button (click)="cancel()" class="btn btn-default btn-flat">Cancel</button>
            </form>
        </div>
    `
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, { onSave: [{
            type: Output,
            args: ['onSave']
        }], canEdit: [{
            type: Input,
            args: ['canEdit']
        }], canAdd: [{
            type: Input,
            args: ['canAdd']
        }], PhoneArray: [{
            type: Input,
            args: ['PhoneArray']
        }], PhoneTypes: [{
            type: Input,
            args: ['PhoneTypes']
        }], editingComponent: [{
            type: Input
        }] }); })();

class EntityComponentsPhonesModule {
}
EntityComponentsPhonesModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EntityComponentsPhonesModule });
EntityComponentsPhonesModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EntityComponentsPhonesModule_Factory(t) { return new (t || EntityComponentsPhonesModule)(); }, imports: [[CommonModule, NgbModule, RouterModule, DynamicFormModule, MtPhoneControlModule, MtAlertsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EntityComponentsPhonesModule, { declarations: function () { return [CommonPhoneComponent]; }, imports: function () { return [CommonModule, NgbModule, RouterModule, DynamicFormModule, MtPhoneControlModule, MtAlertsModule]; }, exports: function () { return [CommonPhoneComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityComponentsPhonesModule, [{
        type: NgModule,
        args: [{
                declarations: [CommonPhoneComponent],
                exports: [CommonPhoneComponent],
                imports: [CommonModule, NgbModule, RouterModule, DynamicFormModule, MtPhoneControlModule, MtAlertsModule]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { CommonPhoneComponent, EntityComponentsPhonesModule };

//# sourceMappingURL=mt-ng2-entity-components-phones.js.map